module.exports = __webpack_public_path__ + "img/zoom_phone_international_calling.01189fd0.svg";